export function header() {
    const $header = $('header');
    const baseThreshold = 70;
    const minWidth = 1160;

    const siteAlerts = document.querySelector('.site-alerts');
    const DISMISS_PREFIX = 'alert-dismissed:';

    // Measured height of the site-alerts banner. The banner is in normal flow
    // (it pushes the header and page content down) and scrolls away with the
    // page, so the sticky threshold is pushed down by this amount.
    let alertsHeight = 0;

    // sessionStorage can throw (private mode, disabled cookies) — fail quietly.
    function isDismissed(id) {
        try {
            return sessionStorage.getItem(DISMISS_PREFIX + id) === 'true';
        } catch (e) {
            return false;
        }
    }
    function rememberDismissed(id) {
        try {
            sessionStorage.setItem(DISMISS_PREFIX + id, 'true');
        } catch (e) {
            /* ignore */
        }
    }

    // Measure the site-alerts banner for the sticky threshold. Layout itself
    // needs no help: the banner is in flow and the header sits at its static
    // position beneath it (see defaults/_header.scss).
    function updateAlertsHeight() {
        alertsHeight = siteAlerts ? siteAlerts.offsetHeight : 0;
    }

    function updateStickyState() {
        if (window.innerWidth < minWidth) {
            $header.removeClass('is-sticky');
            return;
        }
        // Stick once the alert has scrolled past plus the base threshold.
        if ($(window).scrollTop() >= baseThreshold + alertsHeight) {
            $header.addClass('is-sticky');
        } else {
            $header.removeClass('is-sticky');
        }
    }

    // Hide any alerts already dismissed this session BEFORE the first
    // measurement so the sticky threshold starts out correct.
    if (siteAlerts) {
        siteAlerts.querySelectorAll('.alert[id]').forEach((alert) => {
            if (isDismissed(alert.id)) {
                alert.hidden = true;
            }
        });
    }

    updateAlertsHeight();
    updateStickyState();

    // Dismiss an alert: remember it for the session, collapse it (the
    // `is-dismissing` transition in _site-alerts.scss — the header and page
    // content slide up with it because the banner is in flow), then hide it
    // and recalculate the sticky threshold once the transition has ended.
    function dismissAlert(alert) {
        if (alert.id) {
            rememberDismissed(alert.id);
        }
        let fallback = 0;
        const finish = () => {
            clearTimeout(fallback);
            alert.removeEventListener('transitionend', onEnd);
            alert.hidden = true;
            alert.classList.remove('is-dismissing');
            updateAlertsHeight();
            updateStickyState();
        };
        const onEnd = (e) => {
            if (e.target === alert) finish();
        };
        alert.addEventListener('transitionend', onEnd);
        // Safety net in case no transition runs (e.g. transitions disabled).
        fallback = setTimeout(finish, 300);
        alert.classList.add('is-dismissing');
    }

    if (siteAlerts) {
        $(siteAlerts).on('click', '.alert-dismiss', function () {
            const alert = $(this).closest('.alert')[0];
            if (alert && !alert.classList.contains('is-dismissing')) {
                dismissAlert(alert);
            }
        });
    }

    // Recalculate the banner height whenever its content or size changes
    // (alerts added/removed/dismissed, or reflow at a new viewport width),
    // then re-check the sticky threshold against the new height.
    if (siteAlerts && 'ResizeObserver' in window) {
        new ResizeObserver(() => {
            updateAlertsHeight();
            updateStickyState();
        }).observe(siteAlerts);
    }

    $(window).on('scroll resize', updateStickyState);
    $(window).on('resize', updateAlertsHeight);
}
